import type { AllowedModelsTtsEntry } from './voiceAgentTypes';

export type TtsSelectOption = { value: string; label: string };

/** Get first key-value from allowed-models record (display key -> payload value). */
export function recordToTtsOption(r: Record<string, string> | undefined): TtsSelectOption | null {
  if (!r || typeof r !== 'object') return null;
  const entries = Object.entries(r);
  if (entries.length === 0) return null;
  const [label, value] = entries[0];
  return { value: value ?? '', label: label ?? '' };
}

/** Build dropdown options from record: label = key (display), value = value (payload). */
export function recordToTtsOptions(r: Record<string, string> | undefined): TtsSelectOption[] {
  if (!r || typeof r !== 'object') return [];
  return Object.entries(r).map(([label, value]) => ({ label, value: value ?? '' }));
}

/** Find TTS entry by provider value (e.g. "sarvam"). */
export function findTtsEntryByProvider(
  entries: AllowedModelsTtsEntry[],
  providerValue: string
): AllowedModelsTtsEntry | undefined {
  if (!providerValue) return undefined;
  return entries.find((entry) => {
    const option = recordToTtsOption(entry.provider);
    return option?.value === providerValue;
  });
}

export function getTtsProviderOptions(entries: AllowedModelsTtsEntry[]): TtsSelectOption[] {
  return entries
    .map((entry) => recordToTtsOption(entry.provider))
    .filter((option): option is TtsSelectOption => option != null)
    .filter((option) => option.value !== 'dynamic');
}

export function getTtsVoiceOptionsForProvider(
  entries: AllowedModelsTtsEntry[],
  providerValue: string
): TtsSelectOption[] {
  const entry = findTtsEntryByProvider(entries, providerValue);
  if (!entry) return [];
  return recordToTtsOptions(entry.voice_id ?? entry.voice);
}
